import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/pet-discovery/components/PetDiscoveryInteractive.tsx");
